import React from 'react';
import './timesheet-and-invoice-quick-view.css'
import { FlatBadge } from '../../DanitComponents/Badges/FlatBadge';

const TimesheetAndInvoiceQuickView = ({ timesheetId, timesheets, invoices }) => {

    const [timesheet, setTimesheet] = React.useState({})
    const [theFamilies, setTheFamilies] = React.useState({})

    React.useEffect(() => {
        let foundTimesheet = timesheets.find((sheet) => sheet.timesheetId === timesheetId)
        setTimesheet(foundTimesheet)
    }, [])

    React.useEffect(() => {
        if(timesheet.families) {
            compareLessonsWithInvoices(timesheet, invoices)
        }
    }, [timesheet])

    function compareLessonsWithInvoices(timesheet, invoices) {
        const result = {};
    
        // Loop through each family in the timesheet
        for (const family of timesheet.families) {
          const familyName = family.familyName;
          result[familyName] = {};
    
          // Loop through each lesson in the family
          for (const lesson of family.lessons) {
            const studentName = lesson.studentName;
    
            // Initialize the tally for the student from the timesheet
            const timesheetLessonCount = family.lessons.filter(
              (lesson) => lesson.studentName === studentName
            ).length;

            const timesheetCancellationCount = family.cancellations.filter(
                (cancellation) => cancellation.student === studentName && cancellation.cancellor === 'student less than 24hrs'
                ).length;
    
            // Initialize the tally for the student from the invoice (if an invoice exists)
            let invoiceLessonCount = 0;
    
            const invoiceForFamily = invoices.find((invoice) => invoice.familyId === family.id);
            if (invoiceForFamily) {
              invoiceLessonCount = invoiceForFamily.lessonsToBeBilled.filter(
                (lesson) => lesson.studentName === studentName
              ).length;
            }

    
            // Compare the lesson counts
            result[familyName][studentName] = {
              timesheetLessons: timesheetLessonCount,
              invoiceLessons: invoiceLessonCount,
              lessThan24HourCancellations: timesheetCancellationCount,
              isMatch: timesheetLessonCount === invoiceLessonCount,
            };
          }
        }
    
        // Return the comparison result
        console.log(result)
        setTheFamilies(result)
      }

      const checkForAllStudentsInFamilyMatch = (family) => {
            let allStudentsMatch = true
            for (const student in theFamilies[family]) {
                if(!theFamilies[family][student].isMatch) {
                    allStudentsMatch = false
                }
            }
            return allStudentsMatch
        }

    const checkForExtras = (family) => {
        let extras = 0
        //search timesheet for family name
        for (let i = 0; i < timesheet.families.length; i++) {
            if(timesheet.families[i].familyName === family) {
                //search extras for family name
                for (let j = 0; j < timesheet.families[i].extras.length; j++) {
                    extras = extras + timesheet.families[i].extras[j].amount
                }
            }
        }
        return extras
    }




    return (
        <div className="timesheet-and-invoice-quick-view__modal">
            <div className='timesheet-and-invoice-quick-view__teacher-name'>{timesheet.teacherName}</div>
            <div>
              {Object.keys(theFamilies).map((familyName) => (
                <div key={familyName} className='timesheet-and-invoice-quick-view__whole-family'>
                  <div className='timesheet-and-invoice-quick-view__family-name'>{familyName}</div>
                  <div className='timesheet-and-invoice-quick-view__badge_wrapper'>
                    {checkForAllStudentsInFamilyMatch(familyName) ? <FlatBadge text={'Match'} color={{background:'bg-green-200', text: 'text-green-800'}} /> : <FlatBadge text={'Not a match'} color={{background:'bg-red-200', text: 'text-red-800'}} />}
                  </div>
                  <div className='timesheet-and-invoice-quick-view__badge_wrapper'>
                    {checkForExtras(familyName) > 0 ? <FlatBadge text={`$${checkForExtras(familyName)} Extra`} color={{background:'bg-orange-200', text: 'text-orange-800'}} /> : null}
                  </div>
                  <div>
                    {Object.keys(theFamilies[familyName]).map((studentName) => (
                      <div key={studentName}>
                        <div className='timesheet-and-invoice-quick-view__student-data'>
                            <div className="timesheet-and-invoice-quick-view__student-data__student-name">{studentName}</div>
                            {
                                theFamilies[familyName][studentName].isMatch 
                                ?
                                <div className='timesheet-and-invoice-quick-view__student-data__number-of-lessons'>({theFamilies[familyName][studentName].timesheetLessons})</div> 
                                :
                                <div className='timesheet-and-invoice-quick-view__student-data__mismatch-details'>({theFamilies[familyName][studentName].timesheetLessons} on timesheet, {theFamilies[familyName][studentName].invoiceLessons} on invoice)</div>
                            }
                            <div className='timesheet-and-invoice-quick-view__badge_wrapper'>
                                {theFamilies[familyName][studentName].lessThan24HourCancellations > 0 ? <FlatBadge text={`${theFamilies[familyName][studentName].lessThan24HourCancellations} < 24`} color={{background:'bg-red-200', text: 'text-red-800'}} /> : null}
                            </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
        </div>
    )
}
export default TimesheetAndInvoiceQuickView;